export * from 'server/models/ChangePasswordRequest';


// WEBPACK FOOTER //
// ./data/models/ChangePasswordRequest.ts